import React, { useState } from "react";
import { Customer } from "@/pages/dashboard/Customers";
import { CustomerDetails } from "./CustomerDetails";

interface CustomerDetailsPanelProps {
  customer: Customer;
  onUpdateCustomer: (customer: Customer) => void;
}

export function CustomerDetailsPanel({ customer, onUpdateCustomer }: CustomerDetailsPanelProps) {
  const [editMode, setEditMode] = useState(false);
  const [editedCustomer, setEditedCustomer] = useState<Customer>(customer);
  
  const handleChange = (field: keyof Customer, value: string | boolean) => {
    const next = {
      ...editedCustomer,
      [field]: value,
    } as Customer;
    setEditedCustomer(next);

    // If not in edit mode and toggling consent, auto-save via parent
    if (!editMode && (field === 'smsConsent' || field === 'marketingConsent')) {
      onUpdateCustomer({ ...customer, [field]: value } as Customer);
    }
  };
  
  const handleSave = () => {
    onUpdateCustomer(editedCustomer);
    setEditMode(false);
  };
  
  return (
    <CustomerDetails
      customer={customer}
      isEditing={editMode}
      onEdit={() => setEditMode(true)}
      onSave={handleSave}
      editedCustomer={editedCustomer}
      onCustomerChange={handleChange}
    />
  );
}
